
define('css!vendors/jquery/tooltipster/tooltipster',[],function(){});
